import React, { useEffect, useState } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import { setLocalStoarge } from "../../common/allFunctions";
import Select from "react-select";
import { getStateList } from "../../utils/Helpers/GetStateTypes";

export default function StateFilter({
  onSelectStateType,
  reset,
  borderTrue,
  ismultiple,
  preSelectedValues,
  isdisabled
}) {
  const [selectedStateType, setSelectedStateType] = useState(
    ismultiple ? [] : null
  );
  const [stateList, setStateList] = useState([]);

  const transformData = (items) =>
    items
      .map(({ id, name }) => ({
        value: id,
        label: name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

  const getState = () => {
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_STATE_API}`
    )
      .then((response) => {
        const data = response.data?.data || [];
        const transformed = transformData(data);
        setStateList(transformed);
        setLocalStoarge("stateList", JSON.stringify(transformed));
      })
      .catch((error) => console.error(error?.message));
  };

  useEffect(() => {

    const loadData = async () => {
      setStateList( await getStateList());
    };

    loadData();
  }, []);

  useEffect(() => {
    if (
      preSelectedValues?.length > 0 &&
      stateList.length > 0 &&
      (ismultiple ? selectedStateType.length === 0 : !selectedStateType)
    ) {
      const preSelectedOptions = stateList.filter((option) =>
        preSelectedValues.includes(option.value)
      );
      setSelectedStateType(ismultiple ? preSelectedOptions : preSelectedOptions[0] || null);
    }
  }, [stateList, preSelectedValues, ismultiple, selectedStateType]);

  useEffect(() => {
    if (reset) {
      setSelectedStateType(ismultiple ? [] : null);
    }
  }, [reset, ismultiple]);

  const handleChange = (selected) => {
    setSelectedStateType(selected);
    if (ismultiple) {
      onSelectStateType(selected.map((item) => item.value));
    } else {
      onSelectStateType(selected?.value || "");
    }
  };

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (base) => ({
          ...base,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          "&:hover": { borderColor: "#2684FF" },
        }),
        dropdownIndicator: (base) => ({ ...base, color: "#a71e1e" }),
        placeholder: (base) => ({ ...base, color: "#6c757d" }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (base) => ({ ...base, borderRadius: 0 }),
      }}
      options={stateList}
      isMulti={ismultiple}
      value={selectedStateType}
      onChange={handleChange}
      placeholder="Select states..."
      isSearchable
      isDisabled={isdisabled}
    />
  );
}
